import React from 'react'
import { graphql, useStaticQuery, Link } from 'gatsby'
import ProductCard from './ProductCard'

const SectionHiglights = () => {
  const data = useStaticQuery(graphql`
    query {
      contentfulMiseEnAvant(title: {eq: "Promos de la semaine"}){
        title
        description {
          description
        }
        highlightedProducts {
          category {
            name
          }
          id
          price
          pricePromo
          slug
          title
          image {
            fluid(maxHeight: 350, maxWidth: 450) {
              src
              ...GatsbyContentfulFluid_withWebp
            }
          }
        }
      }
    }
  `)

  return (
    <section className="padding section--highlights full-width bg-light-gray">
      <div className="grid-container">
        <h2 className="text-capitalize mb-2 text-center">
          {data.contentfulMiseEnAvant.title}
        </h2>
        <div className="mb-3">
          {data.contentfulMiseEnAvant.description.description}
        </div>
        <div className="highlights--container mb-2">
          {data.contentfulMiseEnAvant.highlightedProducts.map(product => {
            return <ProductCard key={product.slug} product={product} />
          })}
        </div>
        <Link
          className="button large hollow primary-dark centered"
          to="/catalogue"
        >
          Tous nos produits
        </Link>
      </div>
    </section>
  )
}

export default SectionHiglights
